import Slider from 'components/commercetools-ui/atoms/slider';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import useTouchDevice from 'helpers/hooks/useTouchDevice';
import { desktop, smallMobile, tablet } from 'helpers/utils/screensizes';
import React, { memo } from 'react';
import Card, { CardProps } from './card';
import './styles.css';
import card from './card';

export interface CardComparisonProps {
  cardInfos: CardProps[];
  descriptionMinHeight?: number;
  takeCourseDetailsMinHeight?: number;
  whatToExpectMinHeight?: number;
  afterCourseDetailsMinHeight?: number;
  sectionId?: string;
}

const CardComparison: React.FC<CardComparisonProps> = ({
  cardInfos,
  descriptionMinHeight = 0,
  takeCourseDetailsMinHeight = 0,
  whatToExpectMinHeight = 0,
  afterCourseDetailsMinHeight = 0,
  sectionId,
}) => {
  const [isTabletSize] = useMediaQuery(tablet);
  const { isTouchDevice } = useTouchDevice();
  const defaultIndexPerSide = cardInfos.length > 1 ? 2 : 1;

  return (
    <div className="card-comparison bg-padi-gray-lighter" id={sectionId}>
      <div className="mx-auto max-w-2xl px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:px-8">
        <Slider
          dots={!isTabletSize}
          className="!pb-40"
          solidArrows
          arrows={!isTabletSize}
          allowArrowsOnTouchDevice
          allowTouchMove={isTouchDevice}
          nextButtonStyles={{ transform: 'translateY(-150%)', right: '10px' }}
          prevButtonStyles={{ transform: 'translateY(-150%)', left: '10px' }}
          slidesPerView={isTabletSize ? defaultIndexPerSide : 1}
          breakpoints={{
            [smallMobile]: {
              spaceBetween: 0,
            },
            [tablet]: {
              spaceBetween: 18,
            },
            [desktop]: {
              spaceBetween: 32,
            },
          }}
        >
          {cardInfos.map((cardInfo: CardProps) => (
            <Card
              {...cardInfo}
              descriptionMinHeight={descriptionMinHeight}
              takeCourseDetailsMinHeight={takeCourseDetailsMinHeight}
              whatToExpectMinHeight={whatToExpectMinHeight}
              afterCourseDetailsMinHeight={afterCourseDetailsMinHeight}
              key={cardInfo.title}
            />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default memo(CardComparison);
